module.exports = __webpack_public_path__ + "static/2019-Jungle-Minds-Happy-new-decade-80255dd7bd019975a4ab92f650fe5000.pdf";